import { createReducer } from '@reduxjs/toolkit';

import {
  addComment,
  editComment,
  initializeDiscussion,
  poll,
  updateComment,
} from '../actions';
import {
  removeChangeRequests,
  replaceOrPush,
} from '../transform-comment-helpers';

export default createReducer([], {
  [initializeDiscussion]: (state, { payload }) => payload.comments,

  [`${addComment}-success`]: (comments, { payload: newComment }) =>
    replaceOrPush(comments, [newComment]),

  [`${editComment}-success`]: (comments, { payload: updatedComment }) =>
    replaceOrPush(comments, [updatedComment]),

  [`${poll}-success`]: (comments, { payload: newComments }) =>
    replaceOrPush(comments, removeChangeRequests(newComments)),

  [`${updateComment}`]: (comments, { payload: updatedComment }) =>
    replaceOrPush(comments, [updatedComment]),
});
